import { createRoot } from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import "./__product__/language/i18n";
import Provides from "./context/provides";
// eslint-disable-next-line import/extensions
import "./global.d.ts";
import App from "./App";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provides>
    <App />
  </Provides>
);

reportWebVitals();
